/**
 * Platform-detection helpers. Kept tiny on purpose so that callers needing
 * iOS-specific behaviour (e.g. PDF download workarounds) can import them
 * synchronously without pulling in heavier dependencies like jspdf.
 */

/**
 * Detect iOS devices, including iPadOS 13+ which reports a Mac user-agent.
 *
 * Why this exists:
 * - iOS Safari ignores the `download` attribute on `<a>` tags, so jsPDF's
 *   default `doc.save()` (which builds a hidden `<a download>` and clicks it)
 *   silently fails on iPhone / iPad.
 * - Callers that need an iOS-specific code path (synchronous placeholder
 *   window, Web Share API, etc.) check this flag.
 */
export function isIOSDevice(): boolean {
  if (typeof navigator === 'undefined' || typeof document === 'undefined') {
    return false;
  }
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  // iPadOS 13+ masquerades as macOS — distinguish by the presence of touch.
  return ua.includes('Mac') && 'ontouchend' in document;
}
